import type { Member, Trip } from '../../lib/supabase'
import { memberName, noticeText } from '../../lib/sharedTrip'
import { ActionToast, type ToastAction } from '../ui/ActionToast'

// Someone else finished the trip this person was shopping in, away from this
// phone (046), said once (useShopping's `notice`, lib/sharedTrip.ts): "Anna
// finished the trip · 23 items · 24:10", with Keep shopping (a new trip at the
// same store; phone only) or Done — never the summary or the cost, which are
// the finisher's. (Their own watch finish has no toast: Home's Last trip has
// Add cost.) Any answer marks the trip seen.
export function TripToast({ notice, members, phone, onSeen, onKeepShopping }: {
  notice: Trip | null
  members: readonly Pick<Member, 'id' | 'display_name'>[]
  /** Shopping mode is the phone's: elsewhere the note only says what happened. */
  phone: boolean
  onSeen: (tripId: string) => void
  onKeepShopping: (trip: Trip) => void
}) {
  let id: string | null = null
  let text = ''
  let actions: ToastAction[] = []
  if (notice) {
    id = `notice:${notice.id}`
    text = noticeText(notice, memberName(members, notice.finished_by))
    const done = { label: phone ? 'Done' : 'OK', onClick: () => onSeen(notice.id) }
    actions = phone
      ? [{ label: 'Keep shopping', onClick: () => { onSeen(notice.id); onKeepShopping(notice) } }, done]
      : [done]
  }
  if (!id) return null
  return (
    <div className="ml-tab-toast ml-trip-toast">
      <ActionToast id={id} text={text} actions={actions} />
    </div>
  )
}
